import React, {useEffect} from 'react';
import {Affix, Button} from "antd";
import {CloseOutlined, UsergroupAddOutlined} from "@ant-design/icons";
import {useLocation, useParams, useSearchParams} from "react-router-dom";
import {useAuth} from "../../providers/AuthProvider";
import {useIsFetching} from "@tanstack/react-query";

const BulkAddTalentContainer = ({bulkActions, onRunBulkActions,onClearBulkActions,...props}) => {
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();

    const {talentPoolId} = useParams();
    const {auth} = useAuth();

    const isFetchingTalent = useIsFetching(['positionMatches']);

    useEffect(() => {
        if (bulkActions?.length) {
            onClearBulkActions();
        }
    }, [talentPoolId]);


    return (
        <React.Fragment>
            <Affix offsetBottom={15} style={{
            position: "absolute",
            left: 0,
            bottom: 0,
            right: 0,
            zIndex: 100,
            pointerEvents: bulkActions.length > 0 ? 'auto' : 'none'
        }}>
            <div className={TB.mapClass("bulk-actions-container talent-pool-actions", {
                isVisible: bulkActions.length > 0
            })}>
                <p className="font-semibold text-primary text-sm">
                    ({bulkActions.length} selected)
                </p>

                <Button type="text" onClick={async () => {
                    let confirm = await TB.alert("confirm",
                        "Add Talent to Pool",
                        `Are you sure you want to add the selected ${bulkActions?.length} talent to this pool?`, [
                            {title: 'Yes, Continue'},
                            {title: 'Cancel'},
                        ])
                    if (confirm) {
                        let response = await onRunBulkActions()
                    }
                }}>
                    <p className="flex flex-row items-center gap-1.5">
                        <UsergroupAddOutlined style={{fontSize: 30}}/>
                        <span className="capitalize font-medium text-base mt-[2px]">ADD TO POOL</span>
                    </p>
                </Button>


                <CloseOutlined onClick={() => onClearBulkActions()} className="ml-auto"/>

            </div>

        </Affix>
        </React.Fragment>

    )
};

export default BulkAddTalentContainer;